module.exports = __webpack_public_path__ + "static/product-pc-content-3-11cbdedb9e1424fadf0aa1ecac63b22c.jpg";